
<sdps-notification type="error" class="sdps-m-top_none" *ngIf="filterBtnDisableForsubmittedBy">
  <div class="sdps-text-l-body">
    <p class="sdps-notification__text" [innerHTML]="addLinkConstant.pleaseCorrectFollowingError"></p>
    <ul class="sdps-navigation--horizontal__list error-list">
      <li *ngIf="filterBtnDisableForsubmittedBy"
          [innerHTML]="getSharedConstant.textFieldErrorMsg.minCharLimitErrorMsg">
      </li>
    </ul>
  </div>
</sdps-notification>

<div>
  <h2 class="page-title sdps-m-bottom_large sdps-display-inline-block"
      [innerHTML]="getConstant.reports.reportsListPage.reportsTitls"></h2>

  <span class="sdps-m-horizontal_large sdps-m-bottom_medium sdps-display-inline-block client-selection-indicator"
        [ngClass]="this.externalAccess ? 'external-access' : sharedService.showHistoricalView.value ? 'inactive-red' : (addlinkService.clientInformation | async)?.businessUnit | lowercase"
        [innerHTML]="(addlinkService.clientInformation | async)?.k4ClientName">
  </span>

  <!-- Adding Refresh Button in Reports Landing Page -->
  <div>
    <div class="sdps-display-inline-block sdps-is-absolute sdps-m-top_x-small sdps-m-bottom_x-small sdps-p-left_small report-align">
      <div class="sdps-display-inline-block take-action-container sdps-p-right_small">
        <p-select #dropdown aria-label="Take action" [placeholder]="takeActionMenuList[0].label" [(ngModel)]="selectedAction" [options]="takeActionMenuList" (onChange)="showSelectedReportTypeReportList(selectedAction)" [disabled]="!this.sharedService.checkEntitlements(this.entitlementConst.navUUID.emtrAccess.emtrAppAccess.uuid, '', '')">
          <ng-template let-list pTemplate="list">
            <div class="menu-item">
              <span class="menu-list-name">{{list.value}}</span>
            </div>
          </ng-template>
        </p-select>
      </div>
      <button type="button" class="buttons" (click)="sharedService.gutTracking('adobe-lc_refresh|fireonce'); getReportsList(); sharedService.clearErrorMessage();">
        {{getConstant.reports.presetReports.refreshTxt}}
        <em class="sdps-p-left_xxx-small sdps-font-weight-bold sdps-text-small sch-refresh cursor"
            (click)="getReportsList(); sharedService.clearErrorMessage();" title="refresh"></em></button>
    </div>
  </div>

  <ems-table-record-count class="tbl-rec-count" [count]="totalReports" [showTotal]="totalReports"
                          (emitter)="pageObject.pageNo = 1;pageObject.pageSize = $event;applyFilter();"
                          [showHeaderIcons]="true" [showRecords]="paginationCount && paginationCount > getSharedConstant.defaultTableRecords"></ems-table-record-count>
  <form [formGroup]="reportListForm" class="reportListMenu">

  <p-table [columns]="visibleColumns" [value]="reportsList" metaKeySelection="true" [customSort]="true"
           [lazy]="true" (onLazyLoad)="customSort($event)" [multiSortMeta]="multiSortMeta" sortMode="multiple"
           class="common-data-table manage-client-list-table custom-table-filter">
           <ng-template #sorticon pTemplate="sorticon" let-sortOrder>
            <span class="pi" [ngClass]="{
              'pi-sort': sortOrder === 0,
              'pi-caret-down': sortOrder === -1,
              'pi-caret-up': sortOrder === 1,
            }"></span>
          </ng-template>
          <ng-template pTemplate="header" let-columns>
      <tr class="filter-header-input">
        <th class="table-checkbox-selection filter-icon" aria-label="Filter controls">
          <span class="sr-only">Filter controls</span>
          <button type="button" class="btn-icon-only cursor" (click)="toggleFunction()" aria-label="Toggle filter" [attr.aria-expanded]="toggle">
            <em class="pi pi-filter" aria-hidden="true"></em>
          </button>
        </th>
        <th *ngFor="let col of columns" [attr.aria-label]="col.header || 'Column'" [pSortableColumn]="col.field" [pSortableColumnDisabled]="col.field !== 'reportId'" (click)="sharedService.clearErrorMessage()"
            [ngClass]="[(col.field === 'reportId' ? 'w-10-per' : ''), ((col.field === 'reportType' || col.field === 'exportType') ? 'w-20-per' : ''), (col.field === 'action' ? 'w-10-per' : ''), ((paginationCount && paginationCount > 1 || filterClicked) ? 'pointer-events-auto' : 'pointer-events-none')]">
          {{col.header || 'Column'}}
          <p-sortIcon [field]="col.field" *ngIf="col.field ==='reportId' && (paginationCount && paginationCount > 1 || filterClicked)"></p-sortIcon>
        </th>
      </tr>

      <tr *ngIf="this.toggle" class="filtered-row-input">
        <th aria-label="Filter row"><span class="sr-only">Filter row</span></th>
        <th *ngFor="let col of columns" class="sdps-p-left_small" [attr.aria-label]="(col.header || 'Column') + ' filter'">
          <label class="sr-only" [for]="'report_' + col.field" *ngIf="col.field === 'reportId'">{{col.header || 'Report ID'}} filter</label>
          <input pInputText [attr.aria-label]="col.header + ' filter'" [id]="'report_' + col.field" formControlName="{{col.field}}" class="w-100-per" type="text" name="reportId" *ngIf="col.field === 'reportId'"
                 (keydown.enter)="applyFilter()" onkeypress="return (event.which >= 48 && event.which <= 57)">

          <label class="sr-only" [for]="'report_' + col.field" *ngIf="col.field === 'submittedBy'">{{col.header || 'Submitted By'}} filter</label>
          <input pInputText [attr.aria-label]="col.header + ' filter'" [id]="'report_' + col.field" formControlName="{{col.field}}" class="w-100-per" type="text" name="submittedBy" (keydown.enter)="!(filterBtnDisableForsubmittedBy ||reportListForm.get('submittedBy').invalid)? applyFilter() : ''" onkeydown="return (event.keyCode !== 13);"
               emsStartSpaceValidator  *ngIf="col.field === 'submittedBy'" [ngClass]="{'invalidField': (filterBtnDisableForsubmittedBy || reportListForm.get('submittedBy').invalid), 'disabled': filterState === 'disable'}">

          <div class="timePickerForm report-type" *ngIf="col.enum === 'dropdown'">
            <label class="sr-only" [for]="'report_' + col.field">{{col.header || 'Report Type'}} filter</label>
            <p-select appendTo="body" [inputId]="'report_' + col.field" [attr.aria-label]="col.header + ' filter'" [options]="reportTypeDropdown" placeholder=" " formControlName="{{col.field}}"
              class="editableTimepicker request-list-header-dropdown" optionLabel="label">
            </p-select>
          </div>

          <div *ngIf="col.enum === 'multiselect'"
               class="col-2 emtr-dropdown timePickerForm request-list-filter request-list-multiselect-font-size request-list-filter-multiselect">
            <label class="sr-only" [for]="'report_' + col.field">{{col.header || 'Status'}} filter</label>
            <p-multiSelect appendTo="body" [inputId]="'report_' + col.field" [attr.aria-label]="col.header + ' filter'" formControlName="{{col.field}}" [options]="statusFilterOptions"
                           [filter]="true" [defaultLabel]="' '" [displaySelectedLabel]="true" [maxSelectedLabels]="1"
                           [showHeader]="true" [filterPlaceHolder]="'All'" [filter]="true">
            </p-multiSelect>
          </div>

          <div *ngIf="col.enum === 'dateRange'">
            <ems-date-range-filter id="report_submittedDate" #range [disableForm]="filterState === 'disable'" dateFilterLabel="Submitted date filter" (submittedDate)="getSelectedDate($event);" [limitCustomRangeTo1Month]="true"></ems-date-range-filter>
          </div>

          <div *ngIf="col.field === 'action'" class="sdps-p-right_none word-keep-all display-flex">
            <button class="buttons button-filter" [innerHTML]="getConstant.uploadListPage.uploadsListFilter.clearButton"
                    [disabled]="!reportListForm.dirty && !isSortingChanged" (click)="isClearBtnClicked = true;(filterClicked)? clickedClearButton(isSortingChanged) : resetForm(isSortingChanged)"></button>
            <button class="buttons button-save button-filter" [disabled]= "filterBtnDisableForsubmittedBy || reportListForm.invalid" (click)="applyFilter()"
                    [innerHTML]="getConstant.uploadListPage.uploadsListFilter.applyButton"></button>
          </div>
        </th>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage" let-columns>
      <tr>
        <td [attr.colspan]="columns.length + 1" class="sdps-text-center"
            [innerHTML]="getConstant.manageUserPage.noRecords"></td>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-rowData let-columns="columns">
      <tr [pSelectableRow]="rowData">
        <td class="table-checkbox-selection filter-icon"></td>
        <ng-container *ngFor="let col of columns">
        <td *ngIf="col.field !== 'action'" [ngClass]="[(col.field === 'reportId' ? 'w-10-per' : ''), (col.field === 'reportType' || col.field === 'exportType' ? 'w-20-per' : '')]">
          <span *ngIf="col.field === 'reportId'" [innerHTML]="rowData[col.field]"></span>
          <span *ngIf="(col.field === 'clientName' || col.field === 'recordName')">{{rowData[col.field]}}</span>
          <span *ngIf="(col.field === 'reportType' || col.field === 'exportType')">
            <button type="button" class="btn-text-link"
              (click)="navigateToReports(rowData[col.field === 'exportType' ? 'reportType' : col.field])"
              [attr.aria-label]="'View report: ' + rowData[col.field]">
              {{rowData[col.field === 'exportType' ? 'reportType' : col.field]}}
            </button>
          </span>
          <span *ngIf="col.field === 'status'" class="word-keep-all align-item-center display-flex">
            <span class="status sdps-p-around-xx-large" *ngIf="rowData['status'] !== 'Processing'" ngClass="{{rowData[col.field] | lowercase}}">
            </span>
            <span class="status-word-wrap sdps-m-left_x-small" *ngIf="rowData['status'] !== 'Processing'" [innerHTML]="(rowData[col.field] === getConstant.uploadListPage.started || rowData[col.field] === getConstant.uploadListPage.received) ? getConstant.uploadListPage.processingStatus : rowData[col.field] | titlecase"></span>
            <!-- <p-progressBar [value]="rowData['progressValue']" *ngIf="rowData['status'] === 'Processing'" [ngClass]="{'custom-progressbar' : rowData['progressValue'] === 0}"></p-progressBar> -->
            <sdps-progress-indicator sdps-id="loader-determinate" *ngIf="rowData['status'] === 'Processing'" class="custom-progressbar"
                 [attr.helper-text]="rowData['progressValue'] + '%'" [value]="rowData['progressValue']" max="100"
                 sdps-aria-describedby="loading-zone" sr-value-suffix="percent"></sdps-progress-indicator>
          </span>
          <span *ngIf="col.field === 'submittedDate'" [innerHTML]="rowData[col.field]? moment(rowData[col.field]).format('MM/DD/YYYY'): ''"></span>
          <span *ngIf="col.field === 'submittedBy'" [innerHTML]="rowData[col.field]"></span>
        </td>
        </ng-container>
        <td>
          <div class="action-menu-dropdown">
            <button type="button" class="cursor sdps-p-around_xx-small"
                    [attr.aria-label]="'Report actions for ' + rowData['reportType']"
                    aria-haspopup="menu"
                    [attr.aria-expanded]="reportId===rowData['reportId']"
                    (click)="showActionMenu=true; reportId=rowData['reportId']; formMenuItem(rowData);"
                    [ngClass]="{'active-menu':reportId===rowData['reportId']}">
              <em class="pi pi-ellipsis-h sdps-p-around_xx-small" aria-hidden="true"></em>
            </button>
            <p-menu [model]="actionMenu"
                    *ngIf="reportId===rowData['reportId']"
                    class="menu-dropdown" (click)="onActionMenuClick($event, rowData)"></p-menu>
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>
  </form>
  <p-paginator #p *ngIf="paginationCount && paginationCount > getSharedConstant.defaultTableRecords" class="common-pagination" [rows]="pageObject.pageSize" [totalRecords]="paginationCount"
               (onPageChange)="paginate($event);"></p-paginator>
</div>

<app-report-details-modal #reportDetailsModal></app-report-details-modal>
